import { Section } from "@/react/components/Spaces/CustomizeSpaceFullPage/Section";
import { AllWorkflows } from "@circle-react/components/SettingsApp/Workflows/routes/AllWorkflows";

interface WorkflowsProps {
  onClose: () => void;
}

export const Workflows = ({ onClose }: WorkflowsProps) => (
  <Section id="scrollable-container" className="!py-2.5">
    <AllWorkflows
      category="administrative"
      pageSize={4}
      onClose={onClose}
      shouldAutoAdjust
    />
  </Section>
);
